// `#e8a33a` → `[232, 163, 58]`.
export const hexToRgb = (hex: string): [number, number, number] => {
  const value = hex.trim().replace("#", "");
  return [
    Number.parseInt(value.slice(0, 2), 16),
    Number.parseInt(value.slice(2, 4), 16),
    Number.parseInt(value.slice(4, 6), 16),
  ];
};
